export const notFoundErrorMsg = 'Not found.';
export const isNotFoundError = (error: string) => error === notFoundErrorMsg;
